import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
//import { Observable, of } from 'rxjs';

import { Observable, of } from 'rxjs';
import { ImageType } from '../constants/app-constants';
import { AppUrl } from '../constants/app-urls';
import { CarDocumentType } from '../constants/general-basic-data';



const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient) { 

  }

  uploadCarImageFileData(carId: string, file: File): Observable<any> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    const req = new HttpRequest(
                                'POST', 
                                AppUrl.carFiles+"/images/"+carId+"/new",
                                formData, 
                                { reportProgress: true, responseType: 'json' }
        );
        return this.http.request(req);
  }

  uploadCarDocumentFileData(carId: string, file: File): Observable<any> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    let req: any;

    req = new HttpRequest(
            'POST', 
            AppUrl.carFiles+"/documents/"+carId+"/new",
            formData, 
            { reportProgress: true, responseType: 'json' }
    );
    
    return this.http.request(req);
  }

  
  convertDocument(carDocumentType: CarDocumentType, file: File): Observable<any> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    let req: any;

    req = new HttpRequest(
            'POST', 
            AppUrl.carFiles+"/documents/convert/"+carDocumentType.toString(),
            formData, 
            { reportProgress: true, responseType: 'json' }
    );
   
    return this.http.request(req);
  }

  getCarImageFile(filename: string): Observable<any> {
    let params = new HttpParams();

    //filename = "image_picker5614651892198643902.jpg";

    console.log("fetching images, filename = "+filename);

    return this.http.get(
        AppUrl.carFiles+"/images/"+filename,
        {responseType: 'blob', params: params}
        );
    
  }

  getCarDocumentFile(filename: string): Observable<any> {
    let params = new HttpParams();

    //filename = "image_picker5614651892198643902.jpg";

    console.log("fetching documents, filename = "+filename);

    return this.http.get(
        AppUrl.carFiles+"/documents/"+filename,
        {responseType: 'blob', params: params}
        );
    
  }

  uploadCarImageFileOld(file: File): Observable<any> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    const req = new HttpRequest(
                                'POST', 
                                AppUrl.carFiles+"/new",
                                formData, 
                                { reportProgress: true, responseType: 'json' }
        );
        return this.http.request(req);
  }

  getFileOld(imageType: ImageType, destId: string, sellerId: string): Observable<any> {

    let params = new HttpParams();
    params = params.append("sellerId", sellerId);
    
    if(imageType === ImageType.Car) {
        console.log("2 fetching images for car = "+destId);
        return this.http.get(
            AppUrl.carDetails+"/"+destId+"/images/latest",
            {responseType: 'blob', params: params}
            );
    }
    else if(imageType = ImageType.Profile){
        //return this.http.get(AppUrl.carDetails+"/"+destId+"images/latest");
    }
    //return of("type unknown");
    return of();
    
  }

  uploadOld(file: File, imageType: ImageType, destId: string): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    let destUrl = "";

    if(imageType = ImageType.Car) {
        destUrl = AppUrl.carDetails+"/"+destId+"/images/new";
    }
    else if(imageType = ImageType.Profile){

    }

    const req = new HttpRequest('POST', destUrl, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

}